import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnimationOptions } from 'ngx-lottie';
import { interval, Subscription } from 'rxjs';

export interface ProgressData {
  title: string;
  totalDocuments: number;
  currentProgress: number;
  currentDocument?: string;
  estimatedTime?: number;
}

@Component({
  selector: 'progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.scss'],
  standalone: false
})
export class ProgressDialogComponent implements OnInit, OnDestroy {
  private _data: ProgressData;
  progressPercentage: number = 0;
  timeElapsed: number = 0;
  estimatedTimeRemaining: number = 0;
  private timerSubscription?: Subscription;
  options: AnimationOptions = {
    path: '/assets/lotties/file_gen.json',
  };

  get data(): ProgressData {
    return this._data;
  }

  set data(value: ProgressData) {
    this._data = value;
    this.updateProgress();
  }

  constructor(
    public dialogRef: MatDialogRef<ProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ProgressData
  ) {
    this.data = data;
  }

  ngOnInit(): void {
    this.updateProgress();
    this.startTimer();
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private startTimer(): void {
    this.timerSubscription = interval(1000).subscribe(() => {
      this.timeElapsed++;
      this.calculateEstimatedTime();
    });
  }

  private updateProgress(): void {
    if (this.data.totalDocuments > 0) {
      this.progressPercentage = Math.round((this.data.currentProgress / this.data.totalDocuments) * 100);
    } else {
      this.progressPercentage = 0;
    }
  }

  private calculateEstimatedTime(): void {
    if (this.data.currentProgress > 0 && this.timeElapsed > 0) {
      const documentsPerSecond = this.data.currentProgress / this.timeElapsed;
      const remainingDocuments = this.data.totalDocuments - this.data.currentProgress;
      this.estimatedTimeRemaining = Math.round(remainingDocuments / documentsPerSecond);
    }
  }

  updateProgressData(newData: Partial<ProgressData>): void {
    this.data = { ...this.data, ...newData };
    // updateProgress() est automatiquement appelé par le setter
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  static close(): void {
    ProgressDialogComponent.dialog?.close();
  }

  static dialog: MatDialogRef<ProgressDialogComponent> | null = null;
} 